import React from 'react';

// Main component for the Services Section
const ServicesSection = () => {
  // Data for the service cards adapted for Esiteck
  const services = [
    {
      title: "Plomberie",
      image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=512&h=512&fit=crop&crop=center",
      overlayImage: "https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=512&h=512&fit=crop&crop=center"
    },
    {
      title: "Chauffage", 
      image: "https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=512&h=512&fit=crop&crop=center",
      overlayImage: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=512&h=512&fit=crop&crop=center"
    },
    {
      title: "Débouchage",
      image: "https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=512&h=512&fit=crop&crop=center",
      overlayImage: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=512&h=512&fit=crop&crop=center"
    },
    {
      title: "Serrurerie",
      image: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=512&h=512&fit=crop&crop=center",
      overlayImage: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=512&h=512&fit=crop&crop=center"
    }
  ];

  return (
    <div className="bg-white min-h-screen w-full flex items-center justify-center font-sans">
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap');
          body {
            font-family: 'Inter', sans-serif;
          }
        `}
      </style>
      <section className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 w-full">
        <div className="max-w-5xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-blue-900 mb-3 sm:mb-4 tracking-tight">
              Nos Services
            </h2>
            <p className="text-lg sm:text-xl text-gray-500 font-light">
              Des solutions professionnelles pour tous vos besoins techniques.
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="group bg-gray-50 rounded-3xl p-6 flex flex-col h-[320px] transition-all duration-300 hover:bg-gray-100"
              >
                {/* Image Container */}
                <div className="relative flex-grow flex items-center justify-center mb-4">
                  {/* Back Image */}
                  <img
                    src={service.image}
                    alt={`${service.title} showcase`}
                    className="absolute w-44 h-auto rounded-lg shadow-md transform -rotate-6 transition-all duration-400 ease-in-out group-hover:rotate-[-10deg] group-hover:scale-105"
                    onError={(e) => { 
                      e.target.onerror = null; 
                      e.target.src='https://placehold.co/512x512/e2e8f0/4a5568?text=Service+1'; 
                    }}
                  />
                  {/* Front Image */}
                  <img
                    src={service.overlayImage}
                    alt={`${service.title} example`}
                    className="absolute w-44 h-auto rounded-lg shadow-lg transform rotate-3 transition-all duration-400 ease-in-out group-hover:rotate-[5deg] group-hover:scale-105"
                    onError={(e) => { 
                      e.target.onerror = null; 
                      e.target.src='https://placehold.co/512x512/cbd5e0/2d3748?text=Service+2'; 
                    }}
                  />
                </div>

                {/* Service Title */}
                <h3 className="text-left text-lg font-medium text-blue-900 mt-auto">
                  {service.title}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesSection;